import type { EntityTerminology } from '@scrambl/shared';

// Static terminology store for places where hooks can't be used.
// Kept free of React/store imports so low-level modules (api error helpers,
// csv utils, zustand stores) can import it without creating cycles.

export const defaultTerminology: EntityTerminology = {
  singular: 'client',
  plural: 'clients',
};

const staticTerminologyCache = new Map<string, EntityTerminology>();
let currentStaticOrgId: string | null = null;

export function updateStaticTerminology(organizationId: string, terminology: EntityTerminology) {
  staticTerminologyCache.set(organizationId, terminology);
  currentStaticOrgId = organizationId;
}

export function setCurrentStaticOrganization(organizationId: string | null) {
  currentStaticOrgId = organizationId;
}

export function getEntityTerminologyStatic(organizationId?: string): {
  singular: string;
  plural: string;
  Singular: string;
  Plural: string;
} {
  // Use provided org ID, current static org ID, or default
  const orgId = organizationId || currentStaticOrgId;
  const terminology = (orgId && staticTerminologyCache.get(orgId)) || defaultTerminology;

  return {
    singular: terminology.singular,
    plural: terminology.plural,
    Singular: terminology.singular.charAt(0).toUpperCase() + terminology.singular.slice(1),
    Plural: terminology.plural.charAt(0).toUpperCase() + terminology.plural.slice(1),
  };
}
